import React from "react";
import { Search, X } from "lucide-react";

const NEIGHBORHOODS = [
  "Barrio Italia", "Plaza Ñuñoa", "Orrego Luco",
  "Bellavista", "Lastarria", "Providencia", "Ñuñoa", "Las Condes", "Vitacura", "Centro",
];
const BEER_TYPES = ["IPA", "NEIPA", "Stout", "Lager", "Pilsner", "Sour", "Belga", "Weizen", "Porter", "APA", "Saison"];
const AMBIENTS = ["Brewpub", "Pub", "Patio", "Bottle shop", "Sports bar", "Indie", "Outdoor", "Música en vivo"];

export default function FilterBar({ filters, setFilters, onReset }) {
  const update = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="bg-[#1A1A1A] border-2 border-[#333] p-5 space-y-4" data-testid="filter-bar">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A3A3]" />
        <input
          type="text"
          placeholder="BUSCAR LOCAL, BARRIO, CERVEZA…"
          value={filters.q || ""}
          onChange={(e) => update("q", e.target.value)}
          className="w-full bg-[#0A0A0A] border-2 border-[#333] focus:border-[#FEBA01] outline-none pl-10 pr-3 py-3 font-mono uppercase text-sm tracking-wider text-[#F5F5F5] placeholder:text-[#666]"
          data-testid="filter-search-input"
        />
      </div>

      <div>
        <label className="block font-display text-sm uppercase tracking-wider text-[#FEBA01] mb-2">Barrio</label>
        <div className="flex flex-wrap gap-2">
          <Chip active={!filters.neighborhood} onClick={() => update("neighborhood", "")} testid="filter-barrio-todos">Todos</Chip>
          {NEIGHBORHOODS.map((n) => (
            <Chip key={n} active={filters.neighborhood === n} onClick={() => update("neighborhood", n)} testid={`filter-barrio-${n.toLowerCase().replace(/\s/g, "-")}`}>
              {n}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <label className="block font-display text-sm uppercase tracking-wider text-[#FEBA01] mb-2">Tipo de cerveza</label>
        <div className="flex flex-wrap gap-2">
          <Chip active={!filters.beer_type} onClick={() => update("beer_type", "")} testid="filter-beer-todas">Todas</Chip>
          {BEER_TYPES.map((b) => (
            <Chip key={b} active={filters.beer_type === b} onClick={() => update("beer_type", b)} testid={`filter-beer-${b.toLowerCase()}`}>
              {b}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <label className="block font-display text-sm uppercase tracking-wider text-[#FEBA01] mb-2">Ambiente</label>
        <div className="flex flex-wrap gap-2">
          <Chip active={!filters.ambient} onClick={() => update("ambient", "")} testid="filter-ambient-todos">Todos</Chip>
          {AMBIENTS.map((a) => (
            <Chip key={a} active={filters.ambient === a} onClick={() => update("ambient", a)} testid={`filter-ambient-${a.toLowerCase().replace(/\s/g, "-")}`}>
              {a}
            </Chip>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block font-display text-sm uppercase tracking-wider text-[#FEBA01] mb-2">Precio máx</label>
          <select
            value={filters.price_max || ""}
            onChange={(e) => update("price_max", e.target.value ? Number(e.target.value) : "")}
            className="w-full bg-[#0A0A0A] border-2 border-[#333] focus:border-[#FEBA01] outline-none px-3 py-2 font-mono uppercase text-sm text-[#F5F5F5]"
            data-testid="filter-price-select"
          >
            <option value="">Cualquiera</option>
            <option value="1">$ Barato</option>
            <option value="2">$$ Medio</option>
            <option value="3">$$$ Caro</option>
            <option value="4">$$$$ Premium</option>
          </select>
        </div>
        <div>
          <label className="block font-display text-sm uppercase tracking-wider text-[#FEBA01] mb-2">Rating mín</label>
          <select
            value={filters.min_rating || ""}
            onChange={(e) => update("min_rating", e.target.value ? Number(e.target.value) : "")}
            className="w-full bg-[#0A0A0A] border-2 border-[#333] focus:border-[#FEBA01] outline-none px-3 py-2 font-mono uppercase text-sm text-[#F5F5F5]"
            data-testid="filter-rating-select"
          >
            <option value="">Cualquiera</option>
            <option value="3">★ 3.0+</option>
            <option value="4">★ 4.0+</option>
            <option value="4.5">★ 4.5+</option>
          </select>
        </div>
      </div>

      <button
        onClick={onReset}
        className="w-full flex items-center justify-center gap-2 py-2 border border-[#333] text-[#A3A3A3] hover:border-[#FEBA01] hover:text-[#FEBA01] font-mono uppercase text-xs tracking-widest"
        data-testid="filter-reset"
      >
        <X size={14} /> Limpiar filtros
      </button>
    </div>
  );
}

function Chip({ active, onClick, children, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`px-3 py-1.5 border-2 font-mono text-[11px] uppercase tracking-widest transition-colors ${
        active
          ? "bg-[#FEBA01] text-black border-[#FEBA01]"
          : "bg-[#0A0A0A] text-[#F5F5F5] border-[#333] hover:border-[#FEBA01] hover:text-[#FEBA01]"
      }`}
    >
      {children}
    </button>
  );
}
